/* eslint-disable eqeqeq */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import ViewListIcon from "@material-ui/icons/ViewList";
import CardGiftcardOutlinedIcon from "@material-ui/icons/CardGiftcardOutlined";
import {
  CardHeader,
  Divider,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  CircularProgress,
} from "@material-ui/core";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    height: "100%",
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 20,
    marginTop: 5,
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "90%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 20,
    marginBottom: 10,
  },
  cardContent: {
    padding: 0,
    width: "100%",
    overflow: "auto",
  },
  listItem: {
    outline: "none",
    cursor: "pointer",
    padding: 1,
    paddingLeft: 2,
  },
  listItemQAFailed: {
    outline: "none",
    cursor: "pointer",
    padding: 1,
    paddingLeft: 2,
    backgroundColor: "#ffb4b0",
    color: "white",
  },
  listItemDisputed: {
    outline: "none",
    cursor: "pointer",
    padding: 1,
    paddingLeft: 2,
    // backgroundColor:"#fcae1e",
    backgroundColor: "#ffe0a8",
    color: "black",
  },
  statusLabel: {
    fontWeight: 600,
    marginRight: 7,
    fontSize: 14,
    width: "90%",
    overflowWrap: "break-word",
  },
  resize: {
    padding: 10,
  },
  circularProgressStyle: {
    marginTop: 10,
  },
  primaryTextStyle: {
    fontSize: 15,
    overflowWrap: "break-word",
    width: "63%",
  },
  primarySubTextStyle: {
    fontSize: 13,
    overflowWrap: "break-word",
    width: "63%",
  },
  secondaryTextStyle: {
    fontSize: 12,
    color: "#787676",
  },
  filterBtn: {
    fontSize: 11,
    textTransform: "capitalize",
    marginLeft: 4,
    marginRight: 4,
  },
  filterBtnContainer: {
    display: "flex",
    marginBottom: 5,
    marginRight: 5,
    marginLeft: 5,
    width: "max-content",
  },
});

class OrderTab extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Card className={classes.card}>
          <CardHeader
            style={{ padding: 10 }}
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginRight: 15,
                }}
              >
                <span className={classes.title}>
                  <ViewListIcon className={classes.titleIcon} />
                  <b>Orders ({this.props.values.ordersData.length})</b>
                </span>
              </div>
            }
          />
          <Divider className={classes.titleDivider} />

          <CardContent className={classes.cardContent}>
            {this.props.values.ordersDataLoading ? (
              <div className={classes.circularProgressStyle}>
                <CircularProgress />
              </div>
            ) : (
              <List>
                {this.props.values.ordersData.map((card) => {
                  return (
                    <ListItem
                      key={card.orderId}
                      className={
                        card.isDisputed == 1
                          ? classes.listItemDisputed
                          : classes.listItem
                      }
                      onClick={() => this.props.getOrderId(card)}
                      selected={
                        this.props.values.selectedOrder.orderId === card.orderId
                      }
                    >
                      <ListItemAvatar style={{ marginLeft: 10 }}>
                        <Avatar>
                          <CardGiftcardOutlinedIcon />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        disableTypography
                        primary={
                          <Typography className={classes.primaryTextStyle}>
                            {" "}
                            {card.orderId + " - " + card.createdBy} <br />
                            <Typography className={classes.primarySubTextStyle}>
                              {card.email + " - " + card.mobileNo}{" "}
                            </Typography>
                          </Typography>
                        }
                        secondary={
                          <Typography className={classes.secondaryTextStyle}>
                            {card.createdOn}{" "}
                          </Typography>
                        }
                      />
                    </ListItem>
                  );
                })}
              </List>
            )}
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

OrderTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  getOrderId: PropTypes.func,
  onHandleChange: PropTypes.func,
};

OrderTab.defaultProps = {
  values: {},
  getOrderId: (fn) => fn,
  onHandleChange: (fn) => fn,
};

export default withStyles(useStyles)(OrderTab);
